<script>

import { Overlay } from '../../'
import { drawIndicatorPlot } from '../../workspace/indicator-plots.mjs'

export default {
    name: 'Volume',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Volume - Shows trading volume as histogram bars',
                preset: {
                    name: 'Volume',
                    side: 'offchart',
                    settings: {
                        color: '#607d8b'
                    }
                }
            }
        },
        draw(ctx){
            const settings=this.settings,layout=this.layout,plot=settings.$plotConfig?.outputs?.[0]||{};
            const candles=new Map((this.sub||[]).map((row,index,rows)=>[row[0],{row,previous:rows[index-1]}]));
            if(plot.visible!==false){
                if(plot.style&&plot.style!=='histogram')drawIndicatorPlot(ctx,this.data,layout,settings,0);
                else{
                    ctx.save();ctx.globalAlpha=(settings.$opacities?.[0]??settings.opacity??100)/100;
                    const width=Math.max(1,(layout.px_step||4)*.75);
                    for(const row of this.data){
                        if(!Number.isFinite(row[1]))continue;
                        const candle=candles.get(row[0]),up=candle?candle.row[4]>=(settings.colorByPreviousClose?candle.previous?.[4]??candle.row[1]:candle.row[1]):true;
                        ctx.fillStyle=settings.volumeColorMode==='Single'?(plot.color||settings.color||'#607d8b'):(up?settings.upColor||'#26a69a':settings.downColor||'#ef5350');
                        const x=layout.t2screen(row[0]),zero=layout.$2screen(0),y=layout.$2screen(row[1]);
                        ctx.fillRect(x-width/2,Math.min(zero,y),width,Math.abs(zero-y));
                    }
                    ctx.restore();
                }
            }
            if(settings.showMA)drawIndicatorPlot(ctx,this.data,layout,settings,1,{color:settings.maColor||'#2962ff'});
        },
        use_for() { return ['Volume'] },
        calc() {
            return {
                props: {},
                conf: { renderer: 'Histogram' },
                update: `
                    return vol[0]
                `
            }
        }
    }
}
</script>
